<template>
    <div class="content">
        <div class="backButton">
            <button @click="goToList"><i class="fas fa-arrow-left-long"></i> Back</button>
        </div>
        <div class="surveyContainer" v-if="survey">
        <h4>Name: <input type="text" v-model="survey.name" :disabled="!survey.isActive" @blur="saveSurvey('name')" /></h4>
        <h4>Code: <input type="text" v-model="survey.code" :disabled="!survey.isActive" @blur="saveSurvey('code')" /></h4>
        <h4>Status: 
            <span v-if="survey.isActive">Active</span>
            <span v-if="!survey.isActive">Inactive</span>
        </h4>
        <div v-if="survey.configuration">
            <div>
                <LanguageManagement ref="langMang" :objectLanguageArray="survey.languages" :defaultLanguage="survey.defaultLanguage"
                    :onLanguageAdd="addLanguage" :onDefaultChange="changeDefaultLanguage" :onLanguageDelete="deleteLanguage"></LanguageManagement>
            </div>
            <h4>Display:</h4>
            <select v-if="survey.configuration.display && displayTypes" v-model="survey.configuration.display" :disabled="!survey.isActive" @blur="saveSurvey('configuration')">
                <option v-for="dt in displayTypes" :key="dt.value" :value="dt.internalName">{{ dt.displayName }}</option>
            </select>
            <h4>Question Display:</h4>
            <select v-if="survey.configuration.questionDisplay && questionDisplayTypes" v-model="survey.configuration.questionDisplay" :disabled="!survey.isActive" @blur="saveSurvey('configuration')">
                <option v-for="qdt in questionDisplayTypes" :key="qdt.value" :value="qdt.internalName">{{ qdt.displayName }}</option>
            </select>
            <h4>Submit Button Location:</h4>
            <select v-if="submitButtonLocations" v-model="survey.configuration.submitButtonLocation" :disabled="!survey.isActive" @blur="saveSurvey('configuration')">
                <option v-for="sbl in submitButtonLocations" :key="sbl.value" :value="sbl.internalName">{{ sbl.displayName }}</option>
            </select>
            <h4>Breadcrumb:</h4>
            <div v-if="survey.configuration.breadcrumb">
                <p>Enable?</p><input type="checkbox" v-model="survey.configuration.breadcrumb.enable" :disabled="!survey.isActive" @change="toggleBreadcrumb" />
                <p>Show Future Pages?</p><input type="checkbox" v-model="survey.configuration.breadcrumb.showFuturePages" :disabled="!survey.isActive || !survey.configuration.breadcrumb.enable" @change="saveSurvey('configuration')" />
                <p>Separator:</p><input type="text" v-model="survey.configuration.breadcrumb.separator" :disabled="!survey.isActive || !survey.configuration.breadcrumb.enable" @blur="saveSurvey('configuration')" />
            </div>
            <h4>Progress Bar:</h4>
            <div v-if="survey.configuration.progressBar">
                <p>Enable?</p><input type="checkbox" v-model="survey.configuration.progressBar.enable" :disabled="!survey.isActive" @change="saveSurvey('configuration')" />
                <p>Text location</p>
                <select v-if="progressBarTextLocations" v-model="survey.configuration.progressBar.textLocation" :disabled="!survey.isActive || !survey.configuration.progressBar.enable" @blur="saveSurvey('configuration')">
                    <option v-for="pgtl in progressBarTextLocations" :key="pgtl.value" :value="pgtl.internalName">{{ pgtl.displayName }}</option>
                </select>
                <p>Format:</p>
                <p>Use %CURRENT_PAGE% and %TOTAL_PAGES% as wildcards</p>
                <input type="text" v-model="survey.configuration.progressBar.textFormat" :disabled="!survey.isActive || !survey.configuration.progressBar.enable" @blur="saveSurvey('configuration')" />
            </div>
        </div>
        <button class="copyButton" @click="copySurvey">Copy Survey</button>
        <button class="reactivateButton" v-if="!survey.isActive" @click="reactivateSurvey">Reactivate Survey</button>
        <button class="deactivateButton" v-if="survey.isActive" @click="deactivateSurvey">Deactivate Survey</button>
        </div>
        <div class="childrenContainer" v-if="survey">
            <div class="tabsContainer">
                <div v-for="(tab, index) in tabs" @click="currentTab = index" class="tab" :class="{active: currentTab === index}" :key="tab">{{tab}}</div>
            </div>
            <div class="questionsContainer" style="display: flex; flex-direction: column;" v-if="currentTab === 0">
                <div class="pagesContainer">
                    <VueDraggableNext class="dragArea list-group w-full" :list="survey.pages" @update="movePage" >
                        <div v-for="(page, index) in survey.pages" :key="page.id" @click="gotoPage(index)" class="draggable">
                            <i class="fa-solid fa-grip-vertical"></i>
                            <span>Page {{page.pageNumber}}</span>
                        </div>
                    </VueDraggableNext>
                    <div class="addPageButton" @click="addPage()" title="Add Page"><i class="fa-circle-plus fas fa-2xl"></i></div>
                </div>
                <div v-if="activePage">
                    <div class="">
                        <div class="surveyQuestionInfo">
                            <div class="sequence pageNumberContainer">
                                <p style="margin-right: 50px;"><b>Page Number:&nbsp;&nbsp;&nbsp;{{ activePage.pageNumber }}</b></p>
                                <button style="padding: 0px 6px; height: 30px; margin-top: 9px; width: auto; font-size: 16px; background-color: darkred; border-color: darkred; border-radius: 10px; display: flex; color: #FFFFFF; justify-content: center; align-items: center" @click="deletePage()">Delete</button>
                            </div>
                            <div class="sequence">
                                <div style="display: flex; flex-direction: row;">
                                    <p><b>Header Text:</b></p>
                                    <TranslatedText v-if="activePage.headerText && survey.languages && survey.languages.length > 1"
                                                    :textJson="activePage.headerTextJson" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                                </div>
                                <textarea v-model="activePage.headerText" rows="5"  @blur="savePage('headerText')"></textarea>
                            </div>
                            <div class="sequence">
                                <p><b>Configuration</b></p>
                            </div>
                            <div class="configurationRow">
                                <div class="configurationLabel">Back Button:</div>
                                <div class="configurationLabel">Show?</div>
                                <input type="checkbox" id="backButton" v-model="activePage.configuration.backButtonConfig.visible" @change="savePage('configuration')" >
                                <div class="configurationLabel">Value to Display</div>
                                <input type="text" style="width: 150px" id="backButtonText" @blur="savePage('configuration', activePage.id, true, 'backButtonConfig')"  v-model="activePage.configuration.backButtonConfig.text">
                                <TranslatedText v-if="activePage.configuration.backButtonConfig.text && survey.languages && survey.languages.length > 1"
                                    :textJson="activePage.configuration.backButtonConfig.textJson" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                            </div>
                            <div class="configurationRow">
                                <div class="configurationLabel">Continue Button:</div>
                                <div class="configurationLabel">Show?</div>
                                <input type="checkbox" id="backButton" v-model="activePage.configuration.continueButtonConfig.visible" @change="savePage('configuration')">
                                <div class="configurationLabel">Value to Display</div>
                                <input type="text" style="width: 150px" id="backButtonText"  v-model="activePage.configuration.continueButtonConfig.text" @blur="savePage('configuration', activePage.id, true, 'continueButtonConfig')" >
                                <TranslatedText v-if="activePage.configuration.continueButtonConfig.text && survey.languages && survey.languages.length > 1"
                                    :textJson="activePage.configuration.continueButtonConfig.textJson" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                            </div>
                            <div class="configurationRow">
                                <div class="configurationLabel">Skip Button:</div>
                                <div class="configurationLabel">Show?</div>
                                <input type="checkbox" id="backButton" v-model="activePage.configuration.skipButtonConfig.visible" @change="savePage('configuration')">
                                <div class="configurationLabel">Value to Display</div>
                                <input type="text" style="width: 150px" id="backButtonText"  v-model="activePage.configuration.skipButtonConfig.text" @blur="savePage('configuration', activePage.id, true, 'skipButtonConfig')" >
                                <TranslatedText v-if="activePage.configuration.skipButtonConfig.text && survey.languages && survey.languages.length > 1"
                                    :textJson="activePage.configuration.skipButtonConfig.textJson" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                            </div>
                            <div class="configurationRow" v-if="survey.configuration.breadcrumb.enable && activePage.configuration && activePage.configuration.breadcrumbConfiguration">
                                <div class="configurationLabel">Breadcrumb:</div>
                                <div class="configurationLabel">Number</div>
                                <input type="number" v-model="activePage.configuration.breadcrumbConfiguration.number" 
                                    min="1" @blur="saveBreadcrumbConfig()" />
                                <div class="configurationLabel">Title</div>
                                <input type="text" style="width: 150px" v-model="activePage.configuration.breadcrumbConfiguration.title" @blur="saveBreadcrumbConfig()" />
                                <TranslatedText v-if="activePage.configuration.breadcrumbConfiguration.title && survey.languages && survey.languages.length > 1"
                                    :textJson="activePage.configuration.breadcrumbConfiguration.titleJson" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                            </div>
                        </div>
                    </div>
                    <SurveyQuestionList :surveyPage="activePage" :surveyID="survey.id" :allowEdit="survey.isActive"
                        :onUpdate="addQuestionToPage" :key="modalKey"></SurveyQuestionList>
                    <AudioListing :parentID="activePage.id" :grandParentID="survey.id" :actions="survey.actions" :allowEdit="survey.isActive"
                        :onUpdate="refreshSurvey" objectType="SurveyAction"></AudioListing>
                </div>
            </div>
            <div class="actionsContainer" v-if="currentTab === 1">
                <div class="action childObject" v-for="action in nonVariableActions" :key="action.id">
                    <div class="sequenceButtons" v-if="survey.actions.length > 1">
                        <div class="sequenceMinusButton" @click="sequenceMinus(action, survey.actions)" v-if="action.sequence != 1">
                            <i class="fa-solid fa-angle-up"></i>
                        </div>
                        <div>{{ action.sequence }}</div>
                        <div class="sequencePlusButton" @click="sequencePlus(action, survey.actions)" v-if="action.sequence < nonVariableActions.length">
                            <i class="fa-solid fa-angle-down"></i>
                        </div>
                    </div>
                    <div class="notSaved" v-if="!action.id">NOT SAVED! Please complete required fields.</div>
                    <button class="deleteButton" @click="deleteSurveyAction(action)" :disabled="!survey.isActive"><i class="fas fa-trash-can"></i></button>
                    <div class="flex">
                        <div>
                            <div class="surveyActionType">
                                <p><b>Type:</b></p>
                                <p>{{action.type}}</p>
                            </div>
                            <div class="surveyActionType">
                                <p><b>Sub Type:</b></p>
                                <p>{{action.subType}}</p>
                            </div>
                            <div v-if="action.type == 'ShortCirct'">
                                <p><b>Default Action?</b></p>
                                <input type="checkbox" v-model="action.configuration.isDefault" @change="saveSurveyAction(action, 'isDefault')" />
                            </div>
                        </div>
                        <div class="conditionalJson">
                            <div class="detailHeader" style="font-weight: bold; width: unset; display: flex; align-items: baseline;flex-direction: row;">
                                Display Conditions:<i @click="showConditionalModal(action, 'action')" class="fa-pen-to-square fas fa-lg editFieldButton"></i>
                            </div>
                            <div class="conditionalJsonText" v-html="getPrintConditions( action.conditionalJson )"></div>
                        </div>
                    </div>
                    <div class="flexBreak"></div>                    
                    <div v-if="action.type === 'ShortCirct' && action.subType === 'AccordionInformationPage'" style="width: 100%;">
                        <div class="flexRow">
                            <h3>Information Page Accordion Configuration</h3>
                            <button @click="openAccordionConfiguration(action)" class="openModalButton" :disabled="!survey.isActive">
                                <i class="fa-pen-to-square fas fa-2xl"></i>
                            </button>
                        </div>
                        <p v-if="action.configuration && action.configuration.accordionCode">Accordion Code: {{ action.configuration.accordionCode }}</p>
                    </div>
                    <div v-if="action.type === 'ShortCirct' && action.subType === 'SimpleInformationPage'" class="configuration">
                        <p class="configurationTitle" @click="toggleConfiguration(action)">
                            <span v-if="!action.showConfiguration"><i class="fas fa-circle-plus"></i> </span>
                            <span v-if="action.showConfiguration"><i class="fas fa-circle-minus"></i> </span>
                            <b>Simple Information Page Configuration</b>
                        </p>
                        <p v-if="!action.showConfiguration">{{ action.configuration.description.substring(0,100) + '...' }}</p>
                        <div  v-if="action.showConfiguration">
                            <div class="grandChildObject redirectPage">
                                <div>
                                    <p>Description:</p>
                                    <textarea style="min-height: 50px" v-model="action.configuration.description" @blur="saveSurveyAction(action, 'configuration')"></textarea>
                                    <p>Redirect Page Text:</p>
                                    <textarea v-model="action.configuration.displayText" @blur="saveSurveyAction(action, 'displayTextJson')"></textarea>
                                    <TranslatedText v-if="survey.languages && survey.languages.length > 1" :textJson="action.configuration.displayTextJson" 
                                        position="bottom" alignment="start" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%;" v-if="action.type === 'PopupModalWindow' && action.subType === 'OneButtonModal'">
                        <p class="configurationTitle" @click="toggleConfiguration(action)">
                            <span v-if="!action.showConfiguration"><i class="fas fa-circle-plus"></i> </span>
                            <span v-if="action.showConfiguration"><i class="fas fa-circle-minus"></i> </span>
                            <b>Popup/Modal Window Configuration</b>
                        </p>
                        <div v-if="action.showConfiguration" class="configuration popupConfiguration grandChildObject">
                            <div class="flexColumn">
                                <div class="flexRow">
                                    <p>Window Text</p>
                                    <textarea v-model="action.configuration.windowText" @blur="saveSurveyAction(action, 'windowTextJson')"></textarea>
                                    <TranslatedText v-if="survey.languages && survey.languages.length > 1" :textJson="action.configuration.windowTextJson"
                                         position="bottom" alignment="start" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                                </div>
                                <div class="flexRow">
                                    <p>Button Text</p>
                                    <input type="text" v-model="action.configuration.buttonText" @blur="saveSurveyAction(action, 'buttonTextJson')"/>
                                    <TranslatedText v-if="survey.languages && survey.languages.length > 1" :textJson="action.configuration.buttonTextJson"
                                         position="bottom" alignment="start" :defaultLanguage="survey.defaultLanguage"></TranslatedText>
                                </div>
                                <div class="flexRow">
                                    <p>Button Action</p>
                                    <select v-model="action.configuration.buttonAction" @change="saveSurveyAction(action, 'configuration')">
                                        <option v-for="buttonAction in buttonActionTypes" :key="buttonAction.internalName" :value="buttonAction.internalName">{{ buttonAction.displayName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div style="width: 100%;" v-if="action.type === 'PopupModalWindow' && action.subType === 'ButtonModal'">
                        <p class="configurationTitle" @click="toggleConfiguration(action)">
                            <span v-if="!action.showConfiguration"><i class="fas fa-circle-plus"></i> </span>
                            <span v-if="action.showConfiguration"><i class="fas fa-circle-minus"></i> </span>
                            <b>Popup/Modal Window Configuration</b>
                        </p>
                        <ButtonModalConfiguration v-if="action.showConfiguration" :allowEdit="survey.isActive" :action="action"
                                :onUpdate="saveSurveyAction" :languages="survey.languages" :defaultLanguage="survey.defaultLanguage"></ButtonModalConfiguration>
                    </div>        
                    <div class="flexBreak"></div>
                </div>
                <div class="newSurveyActionContainer">
                    <ItemModal  :itemName="'Survey Action'"
                            :formRows="newSurveyActionFormRows"
                            :saveItemFunction="addSurveyActionToList"                            
                            :isActive="survey.isActive"
                            :parentId="survey.id"></ItemModal>
                </div>
            </div>
            <div class="actionsContainer variablesContainer" v-if="currentTab === 2">
                <div class="action childObject" v-for="action in variableActions" :key="action.id">
                    <div class="flexColumn">
                        <div class="sequenceButtons" v-if="survey.actions.length > 1">
                            <div class="sequenceMinusButton" @click="sequenceMinus(action, survey.actions)" v-if="action.sequence != 1">
                                <i class="fa-solid fa-angle-up"></i>
                            </div>
                            <div v-else style="width: 42px;"></div>
                            <div>{{ action.sequence }}</div>
                            <div class="sequencePlusButton" @click="sequencePlus(action, survey.actions)" v-if="action.sequence < variableActions.length">
                                <i class="fa-solid fa-angle-down"></i>
                            </div>
                            <div v-else style="width: 52px;"></div>
                        </div>
                        <div><h4>{{ action.subType }}</h4></div>
                    </div>
                    <button class="deleteButton" @click="deleteSurveyAction(action)" :disabled="!survey.isActive"><i class="fas fa-trash-can"></i></button>
                    <div class="configuration">
                        <div class="notSaved" v-if="!action.id">NOT SAVED! Please complete required fields.</div>
                        <div class="flexRow">
                            <div>
                                <p><b>Attribute</b></p>
                                <select v-model="action.configuration.attributeCode" @change="saveSurveyAction(action, 'configuration')">
                                    <option v-for="attribute in attributes" :key="attribute.id" :val="attribute.code">{{ attribute.code }}</option>
                                </select>
                            </div>
                            <div v-if="action.subType === 'SetConstant'" class="constantValue">
                                <p><b>Value</b></p>
                                <input type="text" v-model="action.configuration.value" @blur="saveSurveyAction(action, 'configuration')" />
                            </div>
                        </div>
                        <div>
                            <div v-if="action.subType === 'LogicalCalculation' && action.configuration">
                                <div class="flexRow">
                                    <p style="flex: 1 1 400px;"><b>Expression</b></p>
                                    <p style="flex: 1 1 200px;"><b>Value</b></p>
                                </div>
                                <div>
                                    <VueDraggableNext class="dragArea list-group w-full" :list="action.configuration.nonElseCalcs" @update="moveCalculation(action)">
                                        <div class="calculation" v-for="(calc, calcInd) in action.configuration.nonElseCalcs" :key="calc.id">
                                            <div class="grip">
                                                <i class="fa-solid fa-grip-vertical"></i>
                                            </div>
                                            <div class="conditionalJson">
                                                <div class="detailHeader" style="font-weight: bold; width: unset; display: flex; padding-right: 10px; align-items: baseline;flex-direction: row;">
                                                    <i @click="showConditionalModalForCalculation(action, calcInd)" class="fa-pen-to-square fas fa-lg editFieldButton"></i>
                                                </div>
                                                <div class="conditionalJsonText" v-html="getPrintConditions( calc.jsonExpression)"></div>
                                            </div>
                                            <div class="formRow value">
                                                <div class="language-value" v-for="(val, valIndex) in calc.valueJson" :key="val.language">
                                                    <div class="language-name">{{ val.language }}</div>
                                                    <div style="display: flex;">
                                                        <input type="text" v-model="val.text" :disabled="!survey.isActive" @blur="saveSurveyAction(action, 'configuration')" />
                                                        <div class="IconContainer" v-if="calc.valueJson.length === 1 || val.language !== 'English'">
                                                            <button @click="deleteCalculation(calcInd, action, valIndex)" class="deleteButton" :disabled="!survey.isActive">
                                                                <i class="fa-trash-can fas fa"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flexBreak"></div>
                                            <div class="IconContainer" v-if="survey.languages.length > 1 && calc.valueJson.length < survey.languages.length">
                                                <button @click="calc.addingLanguage = true" class="addButton" :disabled="!survey.isActive" v-if="!calc.addingLanguage">
                                                    <i class="fa-circle-plus fas fa"></i>
                                                </button>
                                                <select v-if="calc.addingLanguage" @change="addValueToCalculation(calc)" v-model="calc.language">
                                                    <option :val="undefined" disabled>-- Select language --</option>
                                                    <option v-for="lang in availableLanguages(calc.valueJson)" :key="lang.name" :val="lang.name">{{ lang.name }}</option>
                                                </select>
                                            </div>
                                            <hr />
                                        </div>
                                    </VueDraggableNext>
                                    <div class="calculation elseCalculation">
                                        <div style="width: 22px;"></div>
                                        <div class="formRow expression"> {{action.configuration.elseCalc.jsonExpression}}</div>
                                        <div class="formRow value">
                                            <div class="language-value" v-for="(val, valIndex) in action.configuration.elseCalc.valueJson" :key="val.language">
                                                <div class="language-name">{{ val.language }}</div>
                                                <div style="display: flex;">
                                                    <input type="text" v-model="val.text" :disabled="!survey.isActive" @blur="saveSurveyAction(action, 'configuration')" />
                                                    <div class="IconContainer" v-if="action.configuration.elseCalc.valueJson.length === 1 || val.language !== 'English'">
                                                        <button @click="deleteCalculation(calcInd, action, valIndex)" class="deleteButton" :disabled="!survey.isActive">
                                                            <i class="fa-trash-can fas fa"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flexBreak"></div>
                                        <div class="IconContainer" v-if="survey.languages.length > 1 && action.configuration.elseCalc.valueJson.length < survey.languages.length">
                                            <button @click="action.configuration.elseCalc.addingLanguage = true" class="addButton" :disabled="!survey.isActive" v-if="!action.configuration.elseCalc.addingLanguage">
                                                <i class="fa-circle-plus fas fa"></i>
                                            </button>
                                            <select v-if="action.configuration.elseCalc.addingLanguage" @change="addValueToCalculation(action.configuration.elseCalc)" v-model="action.configuration.elseCalc.language">
                                                <option :val="undefined" disabled>-- Select language --</option>
                                                <option v-for="lang in availableLanguages(action.configuration.elseCalc.valueJson)" :key="lang.name" :val="lang.name">{{ lang.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button @click="addCalculation(action)" class="addItemButton"><i class="fa-circle-plus fas fa-2xl"></i></button>
                            </div>
                            <div v-if="action.configuration && (action.subType === 'DateCalculation' || action.subType === 'NumberCalculation')">
                                <h4>Operation:</h4>
                                <div class="grandChildObject operation">
                                    <div v-if="action.subType === 'DateCalculation'">If you want to use the current date at time of use, input NOW in textbox</div>
                                    <div class="formRow">
                                        <div>
                                            <p v-if="action.subType === 'DateCalculation'"><b>Start Date</b></p>
                                            <p v-if="action.subType === 'NumberCalculation'"><b>Value 1</b></p>
                                            <AutoComplete :value="action.configuration.operation.value1"
                                                            :data="surveyAttributes"
                                                            :onValueChanged="updateValue"
                                                            :onBlur="onAutocompleteBlur"
                                                            :placeholder="''"
                                                            :passThruObject="{action: action, input: 'value1'}"
                                                            internalValueField="searchValue"
                                                            displayField="displayValue"
                                                            searchField="searchValue"></AutoComplete>
                                        </div>
                                        <div>
                                            <p><b>Operator</b></p>
                                            <select v-if="action.subType === 'NumberCalculation'" v-model="action.configuration.operation.operator" @change="saveSurveyAction(action, 'configuration')">
                                                <option v-for="op in numericOperators" :key="op.internalName" :value="op.internalName">{{ op.displayName }}</option>
                                            </select>
                                            <select v-if="action.subType === 'DateCalculation'" v-model="action.configuration.operation.operator" @change="saveSurveyAction(action, 'configuration')">
                                                <option v-for="op in dateOperators" :key="op.internalName" :value="op.internalName">{{ op.displayName }}</option>
                                            </select>
                                        </div>
                                        <div v-show="action.configuration.operation.operator !== 'FirstOfMonth'">
                                            <p v-if="action.subType === 'DateCalculation'"><b>End
                                             Date</b></p>
                                            <p v-if="action.subType === 'NumberCalculation'"><b>Value 2</b></p>
                                            <AutoComplete :value="action.configuration.operation.value2"
                                                            :data="surveyAttributes"
                                                            :onValueChanged="updateValue"
                                                            :onBlur="onAutocompleteBlur"
                                                            :placeholder="''"
                                                            :passThruObject="{action: action, input: 'value2'}"
                                                            internalValueField="searchValue"
                                                            displayField="displayValue"
                                                            searchField="searchValue"></AutoComplete>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="action.configuration && action.subType === 'ComplexMathOperation'">
                                <MathOperation :onSave="mathOperationSave" :parentObject="action" 
                                    :attributes="surveyAttributes" :mathConfig="action.configuration"></MathOperation>
                            </div>
                        </div>
                    </div>                    
                </div>
                <div class="newSurveyActionContainer">
                    <ItemModal  :itemName="'Variable'"
                            :formRows="newSetVariableFormRows"
                            :saveItemFunction="addSurveyActionToList"                            
                            :isActive="survey.isActive"
                            :parentId="survey.id"></ItemModal>
                </div>
            </div>
            <AccordionConfiguration v-if="activeAccordionConfigurationAction"
                            :configuration="activeAccordionConfigurationAction.configuration"
                            :parentObject="activeAccordionConfigurationAction"
                            :onFieldUpdate="saveAccordionConfiguration"
                            :onModalClose="closeAccordionConfiguration"
                            :duplicationArray="accordionConfigurations"
                            :defaultLanguage="survey.defaultLanguage"
                            :languages="survey.languages"></AccordionConfiguration>
        </div>
    </div>
    <ConditionalExpressionModal :conditions="conditionGroup" v-if="ExpressionModalVisible" @close="ExpressionModalVisible=false" 
    :onConditionsChanged="updateConditions"></ConditionalExpressionModal>

</template>

<script>
import {data} from '../../shared/data';
import {translation} from '../../shared/translation';
import ItemModal from '@/components/ItemModal.vue';
import { VueDraggableNext} from 'vue-draggable-next';
import AutoComplete from "@/components/shared/AutoComplete.vue";
import AccordionConfiguration from '@/components/accordion/AccordionConfiguration.vue';
import ConditionalExpressionModal from '@/components/shared/ConditionalExpressions/ConditionalExpressionModal.vue';
import { printConditions } from '@/shared/logicProcessing';
import SurveyQuestionList from '@/components/survey/SurveyQuestionList.vue';
import AudioListing from '@/components/mediaproperty/AudioListing.vue';
import TranslatedText from '@/components/shared/TranslatedText.vue';
import LanguageManagement from '@/components/shared/LanguageManagement.vue';
import ButtonModalConfiguration from '@/components/survey/ButtonModalConfiguration.vue';
import MathOperation from '@/components/shared/MathOperation.vue';

export default {
    name: 'SurveyEdit',
    components: { ItemModal, VueDraggableNext, AudioListing, LanguageManagement, ButtonModalConfiguration, MathOperation,
        AutoComplete, ConditionalExpressionModal, AccordionConfiguration, SurveyQuestionList, TranslatedText },
    data: function() {
        return {
            survey: null,
            surveyActionKey: 0,
            showDeletedElements: false,
            logActivityTypes: [],
            displayTypes: [],
            questionDisplayTypes: [],
            submitButtonLocations: [],
            modalKey: 0,
            tabs: ["Questions", "Actions", "Variables"],
            currentTab: 0,
            surveyActionTypes: [],
            setVariableSubTypes: [],
            attributes: [],
            questionTypes: [],
            numericOperators: [],
            dateOperators: [],
            variableAttibutes: [],
            buttonActionTypes: [],
            progressBarTextLocations: [],
            activePage: null,
            activePageIndex: -1,
            initialLoad: true,
            activeAction: null,
            activeCalculationIndex: null,
            activeCalcInput: null,
            activeAccordionConfigurationAction: null,
            newSurveyActionFormRows: [
                {
                    name: 'Sequence',
                    propertyName: 'sequence',
                    required: true,
                    element: 'input',
                    minValue: 1,
                    maxValue: 100
                },
                {
                    name: 'Survey Action Type',
                    propertyName: 'type',
                    required: true,
                    element: 'select',
                    selectOptions: []
                },
                {
                    name: 'Survey Action Sub Type',
                    propertyName: 'subType',
                    required: true,
                    element: 'select',
                    selectOptions: [],
                    dependentField: 'type',
                    availableOptions: [],
                    displayCriteria: { field: 'type', value: '1'}
                }                
            ],
            newSetVariableFormRows: [
                {
                    name: 'Sequence',
                    propertyName: 'sequence',
                    required: true,
                    element: 'input',
                    minValue: 1,
                    maxValue: 100
                },
                {
                    name: 'Sub Type',
                    propertyName: 'subType',
                    required: true,
                    element: 'select',
                    selectOptions: []
                },
                {
                    propertyName: 'type',
                    showIf: false

                }
            ],
            ExpressionModalVisible: false,
            conditionalExpressionObject: null,
            ExpressionObjectType: '',
            conditionGroup: {}
        };
    },  
    mounted() {
        this.getData();
    },
    computed: { 
        variableActions: function() {
            return this.survey.actions.filter(act => {
                return act.type === 'SetVariable';
            });
        },
        nonVariableActions: function() {
            return this.survey.actions.filter(act => {
                return act.type !== 'SetVariable' && act.type !== 'PlayAudio';
            });
        },
        surveyAttributes: function() {
            let returnArr = [];
            this.survey.pages.forEach(pg => {
                pg.questions.forEach(ques => {
                    if(ques.questionInfo.attribute) {
                        if(returnArr.indexOf(ques.questionInfo.attribute.code) < 0)
                            returnArr.push({
                                displayValue: ques.questionInfo.attribute.code,
                                searchValue: ques.questionInfo.attribute.code
                            });
                    }
                })
            });
            this.survey.actions.forEach(act => {
                if(act.configuration.attributeCode)
                    if(returnArr.indexOf(act.configuration.attributeCode) < 0)
                        returnArr.push({
                            displayValue: act.configuration.attributeCode,
                            searchValue: act.configuration.attributeCode
                        });
            });
            returnArr.sort((a,b) => {return b.displayValue - a.displayValue});
            return returnArr;
        },
        accordionConfigurations: function() {
            return this.survey.actions.filter(action => action.type === 'ShortCirct' && action.subType === 'AccordionInformationPage').map(action => action.configuration);
        }
    },
    methods: {
        getPrintConditions: function(conditions) {
            if(conditions != undefined && conditions != '{}' && conditions != '')
                return printConditions(JSON.parse(conditions));
            else 
                return '';
        },
        showConditionalModalForCalculation: function(object, calcIndex) {
            this.activeAction = object;
            this.activeCalculationIndex = calcIndex;
            this.conditionGroup = JSON.parse(object.configuration.nonElseCalcs[calcIndex].jsonExpression);
            this.showConditionalModal(object, 'calc')
        },
        showConditionalModal: function(object, type) {
            if(type != 'calc') {
                if(object.conditionalJson == null || object.conditionalJson == undefined)
                    this.conditionGroup = {};
                else 
                    this.conditionGroup = JSON.parse(object.conditionalJson);
            }

            this.conditionalExpressionObject = object;
            this.ExpressionModalVisible = true;
            this.ExpressionObjectType = type;
        },
        updateConditions: function(conditionGroup) {
            if(this.ExpressionObjectType == 'action') {
                this.conditionalExpressionObject.conditionalJson =  JSON.stringify(conditionGroup);
                this.saveSurveyAction(this.conditionalExpressionObject, 'conditionalJson');
            }
            else if(this.ExpressionObjectType == 'calc') {
                var jsonString = JSON.stringify(conditionGroup);
                if(jsonString == '{}') {
                    this.printErrors('You can not save an empty logical expression.  If this condition needs to be removed, use the delete button');
                    return;
                }
                
                this.activeAction.configuration.nonElseCalcs[this.activeCalculationIndex].jsonExpression = jsonString;// JSON.stringify(conditionGroup);
                this.saveSurveyAction(this.activeAction, 'configuration');        
            }
        },
        movePage: async function(evt) {
            if(evt) {
                var newPageNumber = 0;

                if(evt.newIndex == (this.survey.pages.length - 1)) 
                    newPageNumber = this.survey.pages[evt.newIndex - 1].pageNumber + 1;
                else if(evt.newIndex > 0)
                    newPageNumber = this.survey.pages[evt.newIndex + 1].pageNumber;

                this.reorderPages(this.survey.pages[evt.newIndex].pageNumber, newPageNumber);
            }
        },
        reorderPages: async function(oldPageNumber, newPageNumber) {
            var updatedPages =  await data.reorderSurveyPages(this.survey.id, oldPageNumber, newPageNumber);

            var localPages = [];
            for(var x = 0; x < this.survey.pages.length; x++) { 
                var page = updatedPages.filter(search => search.id == this.survey.pages[x].id);
              
                if(page.length > 0) {
                    localPages.push(this.survey.pages[x]);
                    localPages[localPages.length - 1].pageNumber = page[0].pageNumber;                        
                }
            }

            this.survey.pages = localPages;
                
            this.sortPages();
        },
        sortPages: function() {
            this.survey.pages.sort((a,b) => {
                return a.pageNumber - b.pageNumber;
            });
        },
        getData: async function() {
            const urlParams = new URLSearchParams(window.location.search);
            this.survey = await data.getSurvey(urlParams.get('ID'));

            if(!this.survey.configuration)
                this.survey.configuration = {
                    display: 0,
                    questionDisplay: 0,
                    breadcrumb: {
                        enable: false,
                        showFuturePages: false,
                        separator: '>'
                    },
                    progressBar: {
                        enable: false,
                        textLocation: 'NotSet',
                        textFormat: '%CURRENT_PAGE% / %TOTAL_PAGES%'
                    },
                    submitButtonLocation: ''
                };
            
            if(!this.survey.configuration.breadcrumb)
                this.survey.configuration.breadcrumb = {
                    enable: false,
                    showFuturePages: false,
                    separator: '>'
                }

            if(!this.survey.configuration.submitButtonLocation)
                this.survey.configuration.submitButtonLocation = '';

            if(!this.survey.configuration.progressBar) {
                this.survey.configuration.progressBar = {
                    enable: false,
                    textLocation: 'NotSet',
                    textFormat: '%CURRENT_PAGE% / %TOTAL_PAGES%'
                };
            }

            this.sortPages();

            this.survey.actions.sort((a,b) => {
                return a.sequence - b.sequence;
            });
            this.survey.actions.forEach(async sa =>  {
                if(sa.subType && sa.subType === 'LogicalCalculation') {
                    sa.configuration.inputKey = this.surveyActionKey;
                    this.surveyActionKey++;
                    if(sa.configuration.calculations) {
                        sa.configuration.calculations.sort((a,b) => {return a.sequence - b.sequence;});
                        if(sa.configuration.calculations[sa.configuration.calculations.length - 1].jsonExpression === 'ELSE') {
                            sa.configuration.elseCalc = sa.configuration.calculations.pop();
                        } else {
                            sa.configuration.elseCalc = {jsonExpression: 'ELSE', value: ''};
                        }
                        sa.configuration.nonElseCalcs = sa.configuration.calculations;
                    }
                }
           });
            this.logActivityTypes = await data.getLogActivityTypes('', true);
            this.logActivityTypes.sort((a,b) => {
                if (a.code > b.code) return 1;
                if (a.code < b.code) return -1;
                return 0;
            }); 
            this.attributes = await data.getAllAttributes('', true);
            this.attributes.sort((a,b) => {
                if (a.code > b.code) return 1;
                if (a.code < b.code) return -1;
                return 0;
            });
            this.surveyActionTypes = await data.getEnumList('SurveyActionTypes', false);
            this.newSurveyActionFormRows.find(row => row.propertyName === 'type').selectOptions = this.surveyActionTypes.filter(sat => sat.internalName !== 'SetVariable');

            var subTypeOptions = [
                    { compareValue: 'ShortCirct', options: await data.getEnumList('SurveyActionSubTypes_ShortCircuit', false)},
                    { compareValue: 'PopupModalWindow', options: await data.getEnumList('SurveyActionSubType_PopupModalWindow', false)}
            ];
            this.newSurveyActionFormRows.find(row => row.propertyName === 'subType').availableOptions = subTypeOptions;

            this.setVariableSubTypes = await data.getEnumList('SurveyActionSubTypes_SetVariable', false);
            this.newSetVariableFormRows.find(row => row.propertyName === 'subType').selectOptions = this.setVariableSubTypes;

            this.displayTypes = await data.getEnumList('SurveyDisplayTypes');
            this.questionDisplayTypes = await data.getEnumList('SurveyQuestionDisplayTypes');
            this.submitButtonLocations = await data.getEnumList('SubmitButtonLocations');
            this.questionTypes = await data.getEnumList('QuestionTypes');
            this.numericOperators = await data.getEnumList('Operators_Numeric', false);
            this.dateOperators = await data.getEnumList('Operators_Date', false);
            this.buttonActionTypes = await data.getEnumList('ButtonActionType', false);
            this.languages = await data.getLanguages();
            this.progressBarTextLocations = await data.getEnumList('ProgressBarTextLocations', false);

            if(this.survey.pages && this.survey.pages.length > 0 && this.initialLoad) {
                this.gotoPage(0);
                this.initialLoad = false;
            }
        }, 
        gotoPage(pageNumber) {
            var page = this.survey.pages.length > (pageNumber) ? this.survey.pages[pageNumber] : null;

            this.activePageIndex = pageNumber;
            if(page && page.questions) {
                if(!page.configuration.breadcrumbConfiguration)
                    page.configuration.breadcrumbConfiguration = {
                        number: '',
                        title: ''
                    }
                page.questions.sort((a,b) => {
                    return a.sequence - b.sequence;
                });

                for(let i = 0; i < page.questions.length; i++) {
                    page.questions[i].selectedLogActivityType = this.logActivityTypes.find(lat => lat.typeCode === page.questions[i].logActivityTypeCode);
                }
            }
            else 
                page = null;

            this.activePage = page;
        },
        addPage: async function() {
            this.savePage(null);
        },
        saveBreadcrumbConfig: async function() {
            if(isNaN(this.activePage.configuration.breadcrumbConfiguration.number) ||
                 this.activePage.configuration.breadcrumbConfiguration.number <= 0)
                this.activePage.configuration.breadcrumbConfiguration.number = '';
            
            //javascript does not have Xor, so I got creative.   don't try to save if we don't have both values. 
            if( (this.activePage.configuration.breadcrumbConfiguration.number == '' ? 1 : 0) ^  
                (this.activePage.configuration.breadcrumbConfiguration.title == '') ? 1 : 0)
                return;
            
            this.savePage('configuration', this.activePage.id, true, 'breadcrumbConfiguration');
        },
        savePage: async function(fieldName, id = 0, showSuccessToaster = true, configFieldName = null) {
            let page = {};
            if(!fieldName) {
                var maxPageNumber = 0;
                if(this.survey.pages && this.survey.pages.length > 0 ) {
                    maxPageNumber = this.survey.pages[this.survey.pages.length - 1].pageNumber;
                }

                page = {
                    pageNumber: maxPageNumber + 1,
                    surveyId: this.survey.id,
                    questions: [],
                    configuration: {
                        backButtonConfig: { visible: false, text: 'Back', textJson: [{language: 'English', text: 'Back'}]},
                        continueButtonConfig: { visible: true, text: 'Continue', textJson: [{language: 'English', text: 'Continue'}]},
                        skipButtonConfig: {visible: false, text: 'Skip', textJson: [{language: 'English', text: 'Skip'}]},
                        breadcrumbConfiguration: this.survey.configuration.breadcrumb.enable ? 
                                        { number: maxPageNumber + 1, title: 'Page ' + (maxPageNumber + 1), titleJson: [{language: 'English', text: 'Page ' + (maxPageNumber + 1)}]} : 
                                        { number: 0, title: '', titleJson: [{language: 'English', text: ''}]} 
                    }
                };
            }
            else {
                page.id = id > 0 ? id : this.activePage.id;
                if(fieldName === 'headerText') {
                    this.activePage.headerTextJson = await translation.addTranslations(
                                                        this.activePage.headerTextJson,
                                                        this.activePage.headerText,
                                                        this.survey.languages, this.survey.defaultLanguage);
                    page.headerTextJson = this.activePage.headerTextJson;
                }
                if(fieldName === 'configuration' && configFieldName) {
                    const jsonFieldName = configFieldName === 'breadcrumbConfiguration' ? 'titleJson' : 'textJson';
                    this.activePage.configuration[configFieldName][jsonFieldName] = await translation.addTranslations(
                                                                                this.activePage.configuration[configFieldName][jsonFieldName],
                                                                                this.activePage.configuration[configFieldName][jsonFieldName.replace('Json', '')],
                                                                                this.survey.languages, this.survey.defaultLanguage);
                }
                page[fieldName] = this.activePage[fieldName]; 
            } 

            var result = this.processSaveResult(await data.saveSurveyPage(this.survey.id, page), null, showSuccessToaster);
                      
            if(!fieldName) {
                if(result.success) {
                    page.id = result.id;                
                }

                this.survey.pages.push(page);
                this.gotoPage(this.survey.pages.length - 1);
            }
        },
        deletePage: async function() {
            if(confirm('Are you sure you want to delete this page?')) {
                await this.processDeleteResult(await data.deleteSurveyPage(this.survey.id, this.activePage.id));
                await this.reorderPages(1, 1);
                if(this.survey.pages.length > 0)
                    this.gotoPage(0);
                else 
                    this.activePage = null;

            }
        },
        saveSurvey: async function(fieldName) {
            let obj = {};
            if(fieldName) {
                obj.id = this.survey.id;
                obj[fieldName] = this.survey[fieldName];
            } else {
                obj = this.survey;
            }
            this.processSaveResult(await data.saveSurvey(obj));
        },
        copySurvey: async function() {
            this.processApiResult(await data.copySurvey(this.survey.id), null, true, 'Survey Successfully Copied', 'Survey Copy Failed');            
        },
        reactivateSurvey: async function() {
            this.survey.isActive = true;
            this.processReactivateResult(await data.saveSurvey(this.survey));
        },
        deactivateSurvey: async function() {
            if(confirm('Are you sure you want to deactivate this survey?')) {
                this.survey.isActive = false;
                this.processDeactivateResult(await data.saveSurvey(this.survey));
            }
        },
        refreshSurvey: async function() {
            await this.getData();
            this.gotoPage(this.activePageIndex);           
        },
        addSurveyActionToList: async function(surveyId, sa) {
            var newSA = {
                type: sa.type,
                subType: sa.subType,
                surveyId: surveyId,
                sequence: sa.sequence
            };

            if(sa.type === 'ShortCirct') {
                if(sa.subType === 'AccordionInformationPage')
                    newSA.configuration = {
                        isDefault: false,
                        accordionCode:'',
                        accordionHeaderBackground:'',
                        accordionHeaderBackgroundActive:'',
                        accordionHeaderBackgroundHover:'',
                        accordionHeaderIcon:'',
                        accordionHeaderTextColor:'',
                        accordionHeaderTextColorActive:'',
                        accordionHeaderTextColorHover:'',
                        sectionTitle:'',
                        sectionTitleColor:'',
                        sectionTitleJson: []
                    };
                else if(sa.subType === 'SimpleInformationPage')
                    newSA.configuration = {
                        isDefault: false, 
                        description: '',
                        displayText: '',
                        displayTextJson: ''
                    }; 
            } else if(sa.type === 'PopupModalWindow') {
                if(sa.subType === 'OneButtonModal')
                    newSA.configuration = {
                        windowText: '',
                        buttonText: '',
                        buttonAction: 0,
                        windowTextJson: [],
                        buttonTextJson: []
                    }
                else if(sa.subType === 'ButtonModal')
                    newSA.configuration = {
                        windowTextJson: [],
                        buttons: []
                    }
            } else if(this.setVariableSubTypes.findIndex(st => st.internalName === sa.subType) >= 0) {
                newSA.type = 'SetVariable';
                switch(sa.subType) {
                    case 'SetConstant':
                        newSA.configuration = {
                            attributeCode: '',
                            value: ''
                        };
                        break;
                    case 'LogicalCalculation':
                        newSA.configuration = {
                            inputKey: this.surveyActionKey,
                            attributeCode: '',
                            nonElseCalcs: [],
                            elseCalc: {
                                jsonExpression: 'ELSE',
                                valueJson: [{text: '', language: 'English'}]
                            }
                        }
                        this.surveyActionKey++;
                        break;
                    case 'NumberCalculation':
                    case 'DateCalculation':
                        newSA.configuration = {
                            attributeCode: '',
                            operation: {
                                value1: '',
                                value2: '',
                                operator: 0
                            }
                        }
                        break;
                    case 'ComplexMathOperation':
                        newSA.configuration = {
                            attributeCode: '',
                            equation: '',
                            decimals: 0,
                            dataType: 'Number'
                        }
                        break;
                    default:
                        break;
                }
            }

            this.survey.actions.push(newSA);
            this.survey.actions.sort((a,b) => {return a.sequence - b.sequence;});
            return { success: true };

        },
        saveSurveyAction: async function(sa, fieldName, showToaster = true) {
            var defaultSurveyAction = null;
            var retVal;
            var originalFieldName = fieldName;

            //for default field name....we need to find any active default options and reset them
            if(fieldName === 'isDefault') {
                if(sa.configuration.isDefault === true) {
                    defaultSurveyAction = this.survey.actions.find(search => search.configuration.isDefault === true && search.id != sa.id);
                    if(defaultSurveyAction) {
                        defaultSurveyAction.configuration.isDefault = false;
                        retVal = await data.saveSurveyAction(defaultSurveyAction);
                        if(!retVal.success) { 
                            defaultSurveyAction.configuration.isDefault = true;
                            sa.configuration.isDefault = false;
                            this.processSaveResult(retVal);
                            return;
                        }
                    
                    }
                }

                fieldName = 'configuration';
            }

            if(fieldName === 'displayTextJson') {
                sa.configuration.displayTextJson = await translation.addTranslations(sa.configuration.displayTextJson, sa.configuration.displayText, this.survey.languages, this.survey.defaultLanguage);
                fieldName = 'configuration'
            }
            else if(fieldName === 'sectionTitleJson') {
                sa.configuration.sectionTitleJson = await translation.addTranslations(sa.configuration.sectionTitleJson, sa.configuration.sectionTitle, this.survey.languages, this.survey.defaultLanguage);   
                fieldName = 'configuration'
            }
            else if(fieldName === 'windowTextJson'){
                sa.configuration.windowTextJson = await translation.addTranslations(sa.windowTextJson, sa.configuration.windowText, this.survey.languages, this.survey.defaultLanguage);                        
                fieldName = 'configuration'
            }
            else if(fieldName === 'buttonTextJson') {
                sa.configuration.buttonTextJson = await translation.addTranslations(sa.configuration.buttonTextJson, sa.configuration.buttonText, this.survey.languages, this.survey.defaultLanguage);                        
                fieldName = 'configuration'
            }

            if(fieldName === 'pageNumber') {
                var searchPage =  this.survey.pages.find(pg => pg.pageNumber === sa.configuration.pageNumber);
                if(!searchPage) {
                    var valError = { errors: [ 'Invalid Page Number'] };
                    this.processSaveResult(valError);
                    return;
                } else {
                    sa.configuration.surveyPageID = searchPage.id;
                    fieldName = 'configuration';
                }
            }

            if(fieldName === 'configuration') {
                if(sa.subType === 'LogicalCalculation') {
                    if(sa.configuration.nonElseCalcs.length == 0) {
                        this.$toast.error('All logical expressions must have at least one expression');
                        return;
                    }

                    for(let i = 0; i < sa.configuration.nonElseCalcs.length; i++) {
                        if(sa.configuration.nonElseCalcs[i].jsonExpression && !this.isJsonString(sa.configuration.nonElseCalcs[i].jsonExpression)) {
                            this.$toast.error(`Calculation ${i + 1} is not valid JSON`);
                            return;
                        }
                    }
                    sa.configuration.elseCalc.sequence = sa.configuration.nonElseCalcs[sa.configuration.nonElseCalcs.length - 1].sequence + 1;
                    sa.configuration.calculations = sa.configuration.nonElseCalcs.concat(sa.configuration.elseCalc);
                }
            }

            let obj = {};

            if(fieldName && sa.id) {
                obj.id = sa.id;
                obj.surveyId = sa.surveyId;
                obj[fieldName] = sa[fieldName];
            } else {
                obj = sa;
            }

            var result;
            if(showToaster) {
                result = this.processSaveResult(await data.saveSurveyAction(obj));

                //if this fails and we had previous reset another default survey action...reset that.
                if(!result.success) {
                    if(originalFieldName == 'isDefault') sa.configuration.isDefault = !sa.configuration.isDefault;
                    if(defaultSurveyAction) {
                        defaultSurveyAction.configuration.isDefault = true;
                        retVal = await data.saveSurveyAction(defaultSurveyAction);
                        return;
                    }
                }
            }
            else
                result = await data.saveSurveyAction(obj);

            sa.id = result.id;

            if(this.activeCalcInput) {
                const activeCalcInput = this.activeCalcInput
                const input = this.$refs[activeCalcInput.ref][0];
                input.focus();
                setTimeout(() => {
                    input.selectionStart = activeCalcInput.index + activeCalcInput.addedTextLength;
                    input.selectionEnd = activeCalcInput.index + activeCalcInput.addedTextLength;
                });
                this.activeCalcInput = null;
            } 
        },
        deleteSurveyAction: async function(sa) {
            if(confirm('Are you sure you want to delete this Survey Action?')) {
                this.processDeleteResult(await data.deleteSurveyAction(sa));
                this.getData();
            }
        },
        saveAccordion: async function(sa, acc) {
            sa.accordion = acc;
            if(!sa.configuration)
                sa.configuration = {};
            sa.configuration.accordionCode = sa.accordion.code;
            await this.saveSurveyAction(sa, 'configuration');
        },
        goToList: function() {
            window.location.href = '/surveys';
        },
        colorSample: function(color, defaultColor) {
            if(color) {
                return {
                    'background': color,
                    'background-color': color
                }
            } else if(defaultColor) {
                return {
                    'background': defaultColor,
                    'background-color': defaultColor
                }
            } else {
                return '';
            }
        },
        sequenceMinus: async function(obj, parentArr) {
            if(obj.sequence > 1) {
                obj.sequence--;
                await this.saveSurveyAction(obj, 'sequence');
            }
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
        },
        sequencePlus: async function(obj, parentArr) {
            if(obj.sequence < parentArr.length) {
                obj.sequence ++;
                await this.saveSurveyAction(obj, 'sequence');
            }
            parentArr.sort((a,b) => {return a.sequence - b.sequence;});
        },
        saveConditionalJsonChanges: async function(jsonText, action) {
            action.conditionalJson = jsonText;
            await this.saveSurveyAction(action, 'conditionalJson');
        },
        toggleConfiguration: function(action) {
            if(action.showConfiguration)
                action.showConfiguration = false;
            else
                action.showConfiguration = true;
        },
        toggleBreadcrumb: async function() {
            if(!this.survey.configuration.breadcrumb.enable) {
                let pages = this.survey.pages;
                var result = true;
                //this will go through each page an remove the breadcrumb and save. 
                //It will stop on first error or display success message 
                for(var i = 0; i < pages.length; i++) {
                    var pg = pages[i]; 
                    pg.configuration.breadcrumbConfiguration = null;

                    result = await data.saveSurveyPage(pg.id, pg);
                    if(!result)
                        break;
                }

                if(result)
                    this.showSuccessToaster('Saved');
                else 
                    this.printErrors('Could not save changes');
            } 

            this.saveSurvey('configuration');
            //refresh the current page to ensure page display is updated.
            this.gotoPage(this.activePageIndex);
        },
        addCalculation: function(action) {
            var newSequence = action.configuration.nonElseCalcs.length > 0 ? 
                action.configuration.nonElseCalcs[action.configuration.nonElseCalcs.length - 1].sequence + 1 : 0;

            action.configuration.nonElseCalcs.push({
                sequence: newSequence,
                jsonExpression: '{}',
                valueJson: [{language: 'English', text: ''}]
            })
        },
        setActiveCalc: function(actionId, calcInd) {
            this.activeAction = actionId;
            this.activeCalculationIndex = calcInd;
        },
        sequenceMinusCalculation: async function(calc, action) {
            if(calc.sequence > 1) {
                calc.sequence--;
                await this.saveSurveyAction(action, 'configuration');
            }
            action.configuration.calculations.sort((a,b) => {return a.sequence - b.sequence;});
        },
        sequencePlusCalculation: async function(calc, action) {
            if(calc.sequence < action.configuration.calculations.length) {
                calc.sequence ++;
                await this.saveSurveyAction(action, 'configuration');
            }
            action.configuration.calculations.sort((a,b) => {return a.sequence - b.sequence;});
        },
        deleteCalculation: async function(calcIndex, action, valIndex) {
            if(action.configuration.nonElseCalcs[calcIndex].valueJson.length > 1) {
                if(confirm(`Are you sure you want to delete the ${action.configuration.nonElseCalcs[calcIndex].valueJson[valIndex].language} translation of ${action.configuration.nonElseCalcs[calcIndex].jsonExpression}?`))
                    action.configuration.nonElseCalcs[calcIndex].valueJson.splice(valIndex, 1);
            } else {
                if(confirm(`Are you sure you want to delete the ${action.configuration.nonElseCalcs[calcIndex].jsonExpression} calculation?`))
                    action.configuration.nonElseCalcs.splice(calcIndex, 1);
            }
            await this.saveSurveyAction(action, 'configuration');
        },
        getTypeDescription: function(logActivityTypeCode) {
            return this.logActivityTypes.find(lat => lat.code === logActivityTypeCode).description;
        },
        moveCalculation: function(action) {
            for(var i = 0; i < action.configuration.calculations.length; i++)
                action.configuration.calculations[i].sequence = i + 1;
            
            this.saveSurveyAction(action, 'configuration');
        },
        filterElseCalculations: function(calcs) {
            return calcs.filter(ca => ca.jsonExpression !== 'ELSE');
        },
        updateValue: async function(refObj, newValue) {
            refObj.action.configuration.operation[refObj.input] = newValue;
            //await this.saveSurveyAction(refObj.action, 'configuration');
        },
        onAutocompleteBlur: async function(refObj, newValue) {
            refObj.action.configuration.operation[refObj.input] = newValue;
            await this.saveSurveyAction(refObj.action, 'configuration');
        },
        isJsonString: function(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        },
        saveAccordionConfiguration: async function(config, action) {
            action.configuration = config;
            await this.saveSurveyAction(action, 'configuration');
        },
        openAccordionConfiguration: function(action) {
            this.activeAccordionConfigurationAction = action;
        },
        closeAccordionConfiguration: function() {
            this.activeAccordionConfigurationAction = null;
        },
        addQuestionToPage: async function(surQues) {
            let question = await data.getQuestion(surQues.questionId);
            for(let i = 0; i < this.survey.languages.length; i++) {
                if(question.languages.indexOf(this.survey.languages[i]) < 0) {
                    await this.addLanguageToQuestion(question, this.survey.languages[i]);
                }
            }
            this.refreshSurvey();
        },
        addLanguage: async function(language) {
            this.survey.languages.push(language);
            for(let i = 0; i < this.survey.pages.length; i++) {
                if(this.survey.pages[i].headerText) {
                    await translation.addTranslationToField(this.survey.pages[i].headerTextJson, language, this.survey.defaultLanguage, true);
                 //   await this.savePage('headerTextJson', this.survey.pages[i].id, false);
                }
                if(this.survey.pages[i].configuration.backButtonConfig.text) {
                    await translation.addTranslationToField(this.survey.pages[i].configuration.backButtonConfig.textJson, language, this.survey.defaultLanguage, true);
                //    await this.savePage('configuration', this.survey.pages[i].id, false, 'backButtonConfig');
                }
                if(this.survey.pages[i].configuration.continueButtonConfig.text) {
                    await translation.addTranslationToField(this.survey.pages[i].configuration.continueButtonConfig.textJson, language, this.survey.defaultLanguage, true);
                 //   await this.savePage('configuration', this.survey.pages[i].id, false, 'continueButtonConfig');
                }
                if(this.survey.pages[i].configuration.skipButtonConfig.text) {
                    await translation.addTranslationToField(this.survey.pages[i].configuration.skipButtonConfig.textJson, language, this.survey.defaultLanguage, true);
                //    await this.savePage('configuration', this.survey.pages[i].id, false, 'skipButtonConfig');
                }
                if(this.survey.pages[i].configuration.breadcrumbConfiguration && this.survey.pages[i].configuration.breadcrumbConfiguration.title) {
                    await translation.addTranslationToField(this.survey.pages[i].configuration.breadcrumbConfiguration.titleJson, language, this.survey.defaultLanguage, true);
               //     await this.savePage('configuration', this.survey.pages[i].id, false, 'breadcrumbConfiguration');
                }
                await this.savePage('configuration', this.survey.pages[i].id, false);
                for(let j = 0; j < this.survey.pages[i].questions.length; j++) {
                    if(this.survey.pages[i].questions[j].questionInfo.languages.indexOf(language) < 0)
                        await this.addLanguageToQuestion(this.survey.pages[i].questions[j].questionInfo, language);
                }
            }

            for(let k = 0; k < this.survey.actions.length; k++) {
                switch(this.survey.actions[k].subType) {
                    case "SimpleInformationPage":
                        translation.addTranslationToField(this.survey.actions[k].configuration.displayTextJson, language, this.survey.defaultLanguage, true);
                        break;                        
                    case "AccordionInformationPage":
                        translation.addTranslationToField(this.survey.actions[k].configuration.sectionTitleJson, language, this.survey.defaultLanguage, true);   
                        break;                     
                    case "OneButtonModal":
                        translation.addTranslationToField(this.survey.actions[k].configuration.windowTextJson, language, this.survey.defaultLanguage, true);                        
                        translation.addTranslationToField(this.survey.actions[k].configuration.buttonTextJson, language, this.survey.defaultLanguage, true);                        
                        break;
                }
            }

            await this.saveSurvey(); //'languages');
        },
        addLanguageToQuestion: async function(question, language) {
            question.languages.push(language);
            await translation.addTranslationToField(question.questionTextJson, language, question.defaultLanguage, true);
            await this.saveQuestion(question, 'questionTextJson');
            if(question.moreInfo) {
                await translation.addTranslationToField(question.moreInfoJson, language, question.defaultLanguage, true);
                await this.saveQuestion(question, 'moreInfoJson');
            }
            if(question.answers.length) {
                for(let i = 0; i < question.answers.length; i++) {
                    await translation.addTranslationToField(question.answers[i].answerTextJson, language, question.defaultLanguage, true);
                    const ans = {
                        id: question.answers[i].id,
                        answerTextJson: question.answers[i].answerTextJson
                    }
                    await data.saveAnswer(question.id, ans); 
                }
            }
            if(['Text','SingleSelect','MultiSelect','Combination'].indexOf(question.questionType) >= 0) {
                if(!question.displayParameters.placeholderJson)
                    question.displayParameters.placeholderJson = [];
                await translation.addTranslationToField(question.displayParameters.placeholderJson, language, question.defaultLanguage, true);
                await this.saveQuestion(question, 'displayParameters');
            }
            await this.saveQuestion(question, 'languages');

            if(question.mediaPropertyId) 
                translation.translateMediaProperty(question.mediaPropertyId, question.languages);
        },
        deleteLanguage: async function(lang) {
            const ind = this.survey.languages.indexOf(lang)
            this.survey.languages.splice(ind, 1);
            for(let i = 0; i < this.survey.pages.length; i++) {
                translation.removeLanguageFromField(this.survey.pages[i].headerTextJson, lang);
                //await this.savePage('headerTextJson', this.survey.pages[i].id, false);
                if(this.survey.pages[i].configuration.backButtonConfig.text) {
                    translation.removeLanguageFromField(this.survey.pages[i].configuration.backButtonConfig.textJson, lang);
                 //   await this.savePage('configuration', this.survey.pages[i].id, false, 'backButtonConfig');
                }
                if(this.survey.pages[i].configuration.continueButtonConfig.text) {
                    translation.removeLanguageFromField(this.survey.pages[i].configuration.continueButtonConfig.textJson, lang);
               //     await this.savePage('configuration', this.survey.pages[i].id, false, 'continueButtonConfig');
                }
                if(this.survey.pages[i].configuration.skipButtonConfig.text) {
                    translation.removeLanguageFromField(this.survey.pages[i].configuration.skipButtonConfig.textJson, lang);
                //    await this.savePage('configuration', this.survey.pages[i].id, false, 'skipButtonConfig');
                }
                if(this.survey.pages[i].configuration.breadcrumbConfiguration && this.survey.pages[i].configuration.breadcrumbConfiguration.title) {
                    translation.removeLanguageFromField(this.survey.pages[i].configuration.breadcrumbConfiguration.titleJson, lang);
                //    await this.savePage('configuration', this.survey.pages[i].id, false, 'breadcrumbConfiguration');
                }
            }

            for(let k = 0; k < this.survey.actions.length; k++) {
                switch(this.survey.actions[k].subType) {
                    case "SimpleInformationPage":
                        translation.removeLanguageFromField(this.survey.actions[k].configuration.displayTextJson, lang);
                        break;                        
                    case "AccordionInformationPage":
                        translation.removeLanguageFromField(this.survey.actions[k].configuration.sectionTitleJson, lang);   
                        break;                     
                    case "OneButtonModal":
                        translation.removeLanguageFromField(this.survey.actions[k].configuration.windowTextJson, lang);                        
                        translation.removeLanguageFromField(this.survey.actions[k].configuration.buttonTextJson, lang);                        
                        break;
                }
            }
            await this.saveSurvey();
        },
        changeDefaultLanguage: async function(lang) {
            this.survey.defaultLanguage = lang;
            await this.saveSurvey('defaultLanguage');
        },
        saveQuestion: async function(question, fieldName) {
            let obj = {
                id: question.id
            };
            obj[fieldName] = question[fieldName];

            await data.saveQuestion(obj);
        },
        availableLanguages(value) {
            return this.$refs.langMang.languages.filter(lang => !value.find(val => val.language === lang.name));
        },
        addValueToCalculation: function(calc) {
            calc.valueJson.push({language: calc.language, text: ''});
            calc.addingLanguage = false;
        },
        mathOperationSave: async function(action, mathConfig) {
            action.configuration.equation = mathConfig.equation;
            action.configuration.dataType = mathConfig.dataType;
            action.configuration.decimals = mathConfig.decimals;
            await this.saveSurveyAction(action, 'configuration');
        }
    }
}
</script>

<style scoped>
    input, textarea {
        width: 100%;
    }
    .content {
        display: flex;
        text-align: left;
    }
    .surveyContainer {
        flex: 1 1 100px;
        padding-left: 100px;
        padding-right: 50px;
    }
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .modalForm {
        position: relative;
        border: 1px solid lightgray;
        background-color: white;
        width: 600px;
        padding: 20px;
        text-align: left;
        max-height: calc(100vh - 210px);
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 20;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    .childrenContainer {
        flex: 3 1 800px;
        border-left: 1px solid lightgray;
        padding-left: 30px;
    }
    .tabsContainer{
        display: flex;
        width: 100%;
        margin-top: 20px;
        border-bottom: solid 1px #036991;
    }
    .tab {
        flex: 0 1 150px;
        font-size: 20px;
        border-top: solid 1px #036991;
        border-left: solid 1px #036991;
        border-right: solid 1px #036991;
        margin-right: 10px;
        padding: 10px 0;
        text-align: center;
        background-color: lightblue;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        cursor: pointer;
    }
    .tab.active {
        background-color: #036991;
        color: white;
        cursor: default;
    }
    .configurationRow {
        display:flex;
        flex-direction: row;
        margin-bottom: 10px;
    }
    .configurationLabel {
        margin: 5px 10px 0 25px;
    }
    .actionsContainer {
        position: relative;
    }
    .action {
        position: relative;
        background-color: #e7e7e7;
        border-radius: 10px;
        margin: 20px 0;
        padding: 20px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }
    :deep(.conditionalJson) {
        width: 100%;
    }
    :deep(.conditionalJson textarea) {
        width: 95%;
        min-height: 100px;
    }   
    .grandChildObject {
        display: flex;
        flex-wrap: wrap;
        flex: 1 1 1200px;
    }
    .grandChildObject.informationPage > div:not(.flexBreak) {
        flex: 1 1 200px;
        border: solid 1px gray;
        padding: 10px;
        display: flex; 
    }
    .grandChildObject.informationPage  div.flex-column  {
        display: flex;
        flex-direction: column;  
    }
    .grandChildObject.informationPage  div.flex-row  {
        display: flex;
        flex-direction: row;  
    }
    .grandChildObject div > input[type='text'] {
        width: 200px;
    }
    .grandChildObject.redirectPage > div {
        width: 98%;
    }
    .grandChildObject.redirectPage > div textarea {
        min-height: 200px;
    }
    .reactivateButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        background-color: lightgreen;
        border-color: lightgreen;
        font-size: 16px;
        cursor: pointer;
        margin: 10px 0;
    }
    .deactivateButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        font-size: 16px;
        cursor: pointer;
        margin: 10px 0;
    }
    .editButton{
        position: absolute;
        height: 40px;
        width: 150px;
        font-size: 16px;
        background-color: lightgray;
        border-color: lightgray;
        color: black;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        top: 10px;
        right: 10px;
    }

    .copyButton {
        margin: 10px 0px 0px 0px;
        margin-left: 0px !important;
    }

    :deep(.translationButton), .copyButton {
        height: 40px;
        width: 200px;
        font-size: 16px;
        background-color: lightgray;
        border-color: lightgray;
        color: black;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: -15px;
    }
    .cancelButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
    }
    .deleteButton {
        position: absolute;
        height: 40px;
        width: 100px;
        font-size: 16px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        bottom: 10px;
        right: 10px;
    }
    .deleteButton:disabled {
        color: gray;
    }
    .action .deleteButton {
        padding: 10px;
        margin: auto;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
        font-size: 16px;
        bottom: unset;
        color: black;
        width: 50px;
    }
    .IconContainer {
        width: 100%;
        display: flex;
        justify-content: right;
    }
    .addButton {
        padding: 10px;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
        color: black;
        position: relative;
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .question {
        display: flex;
        position: relative;
        background-color: #e7e7e7;
        border-radius: 10px;
        margin: 20px 0;
        padding: 10px;
    }
    .questionInfo {
        flex: 3 1 400px;
    }
    .questionText {
        width: 100%;
    }
    .questionType, .answerType {
        width: 48%;
        display: inline-block;
    }
    .surveyQuestionInfo {
        flex: 1 1 100px;
        margin-right: 20px;
        padding-right: 10px;
    }
    .sequenceButtons span{
        margin-left: 12px;
    }
    .sequenceButtons {
        display: flex;
        flex-direction: row;
        flex: 0 0 150px;
        font-size: 28px;
        height: 50px;
        align-items: center;
    }
    .variablesContainer .sequenceButtons {
        flex: unset;
        margin-right: 50px;
    }
    .calculation .sequenceButtons {
        font-size: unset;
        height: unset;
        margin: unset;
        flex: 1 1 75px;
    }
    .calculation .sequenceButtons .sequencePlusButton, .calculation .sequenceButtons .sequenceMinusButton {
        font-size: unset;
        padding: 5px;
    }
    .calculation .sequenceButtons .sequencePlusButton.disabled, .calculation .sequenceButtons .sequenceMinusButton.disabled {
        background-color: gray;
        cursor:not-allowed;
    }
    .calculation .deleteButton {
        position: relative;
        font-size: unset;
        padding: unset;
        height: 30px;
        width: 30px;
    }
    .surveyActionType {
        margin-right: 50px;
    }
    .surveyActionType .surveyActionDestination {
        flex: 1 1 400px;
    }
    .sequenceMinusButton {
        margin: 0 10px 0 0;
        width: 12px;
    }
    .sequencePlusButton {
        margin: 0 0 0 10px;
        width: 12px;
    }
    .configuration {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1 1 500px;
    }
    .configuration > .flexRow {
        justify-content: space-between;
    }
    .configuration .constantValue {
        margin-right: 100px;
    }
    .configurationTitle {
        cursor: pointer;
    }
    .configurationTitle span {
        margin-right: 10px;
        font-size: 24px;
    } 
    .flex {
        display: flex;
        width: 100%;
    }
    .pagesContainer {
        background-color: #036991;
        display: flex;
        flex-direction: row;
        flex: 1 0;
        min-height: 40px;
    }   
    .dragArea {
        display: flex; 
        flex-direction: row;
        padding: 5px;
        flex-wrap: wrap;
        padding-right: 40px;
    }
    .draggable {    
        border-radius: 5px;
        border: 1px solid #2F2F52;
        padding: 5px;
        margin: 1px 1px;
        display: flex;
        background-color: white;
        cursor: pointer;
        flex: 0 1 75px;
        white-space: nowrap;
        align-items: center;
    }
    .draggable i {
        color: #036991;
        padding-right: 9px;
    }
    .addPageButton {
        color: #FFD831;
        margin: auto 20px auto 0px;
        cursor: pointer;
    }
    .pageNumberContainer {
        display: flex; 
        flex-direction: row; 
        justify-content: space-between;
    }   
    .fieldLabel {
        flex: 0 1 75px;
        margin-right: 10px;
        font-weight: bold;
    }
    .dataEntryRow {
        margin-bottom: 5px;
        display: flex; 
        flex-direction: row; 
        align-items: center;
    }
    .modalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 16px;
        color:#036991;
    }
    .colorSample {
        align-self: center;
    }
    .colorSampleContainer {
        display: flex;
        flex: 1 1;
        justify-content: center;
    }
    .newSurveyActionContainer {
        position: fixed;
        bottom: 29px;
        right: 75px;
    }
    .notSaved {
        color:red;
         margin: auto 20px; 
         width: 300px
    }
    .addItemButton {
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 16px;
        color:#036991;
    }
    .calculation {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 100%;
        flex-wrap: wrap;
        cursor: grab;
    }
    .elseCalculation {
        cursor: unset;
    }
    
    .calculation .grip {
        margin: 7px 10px 0 0;
    }
    .calculation hr {
        margin: 5px 0;
    }
    .calculation .formRow input {
        height: 20px;
        width: 90%;
        min-width: 35ch;
        margin-right: 15px;
    }
    .calculation .formRow.expression {
        flex: 1 1 400px;
    }
    .calculation .formRow.value {
        flex: 1 1 200px;
    }
    .elseCalculation .value, .elseCalculation > .IconContainer {
        margin-right: 40px;
    }
    .configuration .addItemButton {
        margin-top: 20px;
    }
    .operation {
        display: flex;
        flex-direction: row;
        flex: 1 1 50px;
    }
    .operation div {
        display: flex;
        justify-content: space-between;
    }
    .operation div div {
        display: flex;
        flex-direction: column;
    }
    .operation select {
        margin-top: 5px;
    }
    .elseButton {
        left: -70px;
        position: absolute;
    }
    .elseButton button {
        border: black solid 1px;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        height: 27px;
    }
    .conditionalJsonButtonContainer {
        flex: 2 1 400px;
    }
    .conditionalJsonButtonContainer button {
        margin: 0 20px 10px 0;
        padding: 5px;
        background-color: #FFD831;
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
    }


    .popupConfiguration .flexColumn, .popupConfiguration .flexRow {
        width: 100%;
    }
    .popupConfiguration div.flexRow {
        margin: 10px 0;
    }
    .popupConfiguration p {
        flex: 0 0 167px;
    }

    .popupConfiguration textarea {
        flex: 1 1 300px;
        min-height: 100px;
    }

    .popupConfiguration input, .popupConfiguration select {
        flex: 0 1 300px;
    }
    .openModalButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        font-size: 12px;
        color:#036991;
    }
    :deep(.conditionalJson) {
        flex: 1 1 400px;
        display: flex;
        flex-direction: row; 
        align-items: center;
    }


    :deep(.conditionalJson div) {
        display: inline;
    }

    .editFieldButton {
        display: inline-block;
        background-color: unset;
        border: none;
        cursor: pointer;
        color:#036991;
        margin-left: 10px;
    }

    .conditionalJsonText {
        margin-right: 20px;
    }
</style>